export const sedan = [
  {
    id: 1,
    name: "Hyundai Aura AC",
    image: "/images/gallery/sedan/aura.jpg",

    gallery: [
      "/images/gallery/sedan/aura.jpg",
      "/images/gallery/sedan/aura-interior.jpg",
      "/images/gallery/sedan/aura-tyre.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1197 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC"
  },

  {
    id: 2,
    name: "Maruti Dzire AC",
    image: "/images/gallery/sedan/dzire.jpg",

    gallery: [
      "/images/gallery/sedan/dzire.jpg",
      "/images/gallery/sedan/dzire-interior.jpg",
      "/images/gallery/sedan/dzire-tyre.jpg",
      
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1197 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / CNG",
    ac: "AC"
  },

  {
    id: 3,
    name: "Honda Amaze AC",
    image: "/images/gallery/sedan/amaze.jpg",

    gallery: [
      "/images/gallery/sedan/amaze.jpg",
      "/images/gallery/sedan/amaze-interior.jpg",
      "/images/gallery/sedan/amaze-tyre.jpg"
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "1199 cc",
    transmission: "Manual / Automatic",
    fuel: "Petrol / Diesel",
    ac: "AC"
  }
];
